import { z } from "zod";

export const permissionTypes = ["view", "create", "update", "delete"] as const;
export type PermissionType = (typeof permissionTypes)[number];

// Form data schema for creating/updating roles
export const roleSchema = z.object({
  name: z.string().min(1, "Role name is required"),
  description: z.string().optional(),
  permissionIds: z
    .array(z.string())
    .min(1, "At least one permission is required"),
});

export type RoleFormData = z.infer<typeof roleSchema>;

export interface Permission {
  id: string;
  action: string;
}

export interface Role {
  id?: string;
  name: string;
  description?: string | null;
  tenantId?: string | null;
  permissions: Permission[];
}

export interface CreateRoleRequest {
  name: string;
  description?: string;
  permissionIds: string[];
}

export interface UpdateRoleRequest {
  id: string;
  name: string;
  description?: string;
  permissionIds: string[];
}
